import { render, staticRenderFns } from "./checkbox.vue?vue&type=template&id=d0387074&"
import script from "./checkbox.vue?vue&type=script&lang=js&"
export * from "./checkbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/builds/MWmsPKDH/0/framework/qmai-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d0387074')) {
      api.createRecord('d0387074', component.options)
    } else {
      api.reload('d0387074', component.options)
    }
    module.hot.accept("./checkbox.vue?vue&type=template&id=d0387074&", function () {
      api.rerender('d0387074', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "packages/checkbox/src/checkbox.vue"
export default component.exports